export enum PROCESSING_STATE {
  NOT_LOADED,
  LOADING,
  LOADED,
  PROCESSING,
  DONE
}
